import { render, staticRenderFns } from "./MedicalPaymentListTable.vue?vue&type=template&id=3772711c&scoped=true&"
import script from "./MedicalPaymentListTable.vue?vue&type=script&lang=js&"
export * from "./MedicalPaymentListTable.vue?vue&type=script&lang=js&"
import style0 from "./MedicalPaymentListTable.vue?vue&type=style&index=0&id=3772711c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3772711c",
  null
  
)

export default component.exports